import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';

export type createFolderType = {
  folderTypologyId: string;
  folderId: string;
};

const createFolderByTypologyAsync = ({ folderTypologyId, folderId }: createFolderType) =>
  axios.post(`/folders/${folderId}`, { folderTypologyId });

export const useCreateFolderByTypologyAsync = () =>
  useMutation({
    mutationFn: createFolderByTypologyAsync,
  });
